<template>
    <div class="grid grid-cols-12 gap-3 mt-3" id="statistics-section">
        <div class="col-span-12 mt-5 flex justify-between items-center flex-wrap">
            <div class="flex items-center text-gray-600 data-group mt-3 md:mt-0" data-test="data-level">
                <p class="text-md font-medium truncate mr-2">
                ระดับของข้อมูล :
                </p>
                <div class="w-72">
                    <v-select
                        class=""
                        data-test="main-category"
                        id="main-category-select"
                        v-model="valueSelected"
                        :options="options"
                        :clearable="false"
                        :searchable="true"
                        placeholder="ระดับข้อมูล"
                        @option:selecting="handleSelectedChange"
                        @open="handleOpenDropdown"
                    >
                        <template #no-options="{}">
                            ไม่พบข้อมูล
                        </template>
                        <template #open-indicator="{ attributes }">
                            <span v-bind="attributes"><ChevronDownIcon class="w-5 h-5"/></span>
                        </template>
                    </v-select>
                    <search-dropdown
                        v-model="showDropdownFilter"
                        class="rounded-md"
                        :valueSelected="valueSelected" :is-all="valueSelected == 'ทั้งประเทศ'"
                        :current-search="currentSearching"
                        @click:cancel="handleClickCancel"
                        @click:save="handleSearch"
                    ></search-dropdown>
                </div>
            </div>
        </div>
        <div class="col-span-12 mt-1" v-if="valueSelected != 'ทั้งประเทศ'">
            <div class="flex">
                <p class="text-md font-medium truncate mr-2 text-gray-600">
                    เงื่อนไขการค้นหา :
                </p>
                <i class="text-md">
                    {{searchResultText}}
                </i>
            </div>
        </div>
        <div class="col-span-12">
            <div class="grid grid-cols-12 gap-6 relative">
                <div class="col-span-12 dashboard2:col-span-8">
                    <div class="report-box-2 intro-y mt-2 h-full">
                        <LoadingScreen
                            :ifLoading="loadingStat"
                        />
                        <div class="box dashboard1:flex h-full">
                            <div class="px-4 py-4 flex-1 flex flex-col justify-center relative">
                                <div class="flex items-center text-gray-600 absolute top-4" data-test="data-option">
                                    <p class="text-md font-medium truncate mr-2 ">
                                        แสดงข้อมูลราย :
                                    </p>
                                    <div class="box">
                                        <div class="flex rounded-md border border-gray-300 overflow-hidden">
                                            <fieldset class="flex-grow text-center">
                                                <input
                                                class="peer"
                                                type="radio"
                                                name="name"
                                                id="firstOptionId"
                                                value="hh"
                                                v-model="selectState"
                                                >
                                                <label
                                                class="inline-block text-md w-full py-2 px-2 cursor-pointer text-theme-37 hover:bg-gray-100 peer-checked:bg-theme-1 peer-checked:text-white select-none"
                                                for="firstOptionId"
                                                >ครัวเรือน</label>
                                            </fieldset>
                                            <fieldset class="flex-grow text-center border-l border-gray-300">
                                                <input
                                                class="peer"
                                                type="radio"
                                                name="name"
                                                id="secondOptionId"
                                                value="fam"
                                                v-model="selectState"
                                                >
                                                <label
                                                class="flex items-center text-md w-full h-full py-2 px-2 cursor-pointer text-theme-37 hover:bg-gray-100 peer-checked:bg-theme-1 peer-checked:text-white select-none"
                                                for="secondOptionId"
                                                >ครอบครัว</label>
                                            </fieldset>
                                            <fieldset class="flex-grow text-center border-l border-gray-300">
                                                <input
                                                class="peer"
                                                type="radio"
                                                name="name"
                                                id="thirdOptionId"
                                                value="member"
                                                v-model="selectState"
                                                >
                                                <label
                                                class="flex items-center text-md w-full h-full py-2 px-2 cursor-pointer text-theme-37 hover:bg-gray-100 peer-checked:bg-theme-1 peer-checked:text-white select-none"
                                                for="thirdOptionId"
                                                >สมาชิก</label>
                                            </fieldset>
                                        </div>
                                    </div>
                                </div>
                                <div class="px-8 py-8 mt-4 flex flex-col justify-center">
                                    <HomeIcon v-show="selectState == 'hh'" class="w-10 h-10 text-theme-36 !stroke-2" />
                                    <UsersIcon v-show="selectState == 'fam'" class="w-10 h-10 text-theme-36 !stroke-2" />
                                    <UserIcon v-show="selectState == 'member'" class="w-10 h-10 text-theme-36 !stroke-2" />
                                    <div class="relative text-5xl font-bold mt-6 pl-2">
                                        <h1 class="text-custom-member opacity-90" >
                                            <!-- {{
                                                new Intl.NumberFormat('en-GB', {
                                                notation: "compact",
                                                compactDisplay: "short"
                                                }).format(statsProblemData?.allstats?.length>0 ? (statsProblemData.allstats[0].prob_family + statsProblemData.allstats[0].prob_occupation + statsProblemData.allstats[0].prob_health + statsProblemData.allstats[0].prob_accessibility + statsProblemData.allstats[0].prob_education) : 0)
                                            }} -->
                                            {{statsProblemData?.allstats?.length>0 ? millionShortNum(statsProblemData.allstats[0].prob_family + statsProblemData.allstats[0].prob_occupation + statsProblemData.allstats[0].prob_health + statsProblemData.allstats[0].prob_accessibility + statsProblemData.allstats[0].prob_education) + ' '+ millionShortString(statsProblemData.allstats[0].prob_family + statsProblemData.allstats[0].prob_occupation + statsProblemData.allstats[0].prob_health + statsProblemData.allstats[0].prob_accessibility + statsProblemData.allstats[0].prob_education) : 0}}
                                            <span class="text-base">{{selectStateComputed}}</span>
                                        </h1>
                                    </div>
                                    <div class="mt-4 text-gray-600 dark:text-gray-600 max-w-[180px]">
                                        <div class="text-theme-36">จำนวน{{selectStateComputed}}ที่ประสบปัญหา</div>
                                        <div class="text-base mt-2">
                                            {{selectStateComputed}}ที่มีปัญหาอย่างน้อย 1 ด้าน
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                class="px-4 py-8 flex flex-col justify-center flex-1 border-t sm:border-t-0 sm:border-l border-gray-300 dark:border-dark-5 border-dashed"
                            >
                                <div class="box px-3 py-1 mb-3 flex items-center zoom-in bg-gray-100 box-shadow text-right font-bold">
                                    <div class="w-11 h-11 flex-none image-fit rounded-md overflow-hidden">
                                        <button class="btn btn-secondary mr-1 border-0 rounded-full w-11 h-11 p-2 text-white hover:bg-theme-36 bg-theme-36">
                                        <HeartIcon class="!stroke-2"/>
                                        </button>
                                    </div>
                                    <div class="ml-auto">
                                        <div class="font-medium text-gray-600">สุขภาพ</div>
                                        <div class="text-custom-member text-md mt-0.5 text-right text-4xl" style="min-height: 40px;">
                                            {{statsProblemData?.allstats?.length>0 ? millionShortNum(statsProblemData.allstats[0].prob_health) + ' '+ millionShortString(statsProblemData.allstats[0].prob_health) : 0}}
                                        </div>
                                    </div>
                                </div>
                                <div class="box px-3 py-1 mb-3 flex items-center zoom-in bg-gray-100 box-shadow text-right font-bold">
                                    <div class="w-11 h-11 flex-none image-fit rounded-md overflow-hidden">
                                        <button class="btn btn-secondary mr-1 border-0 rounded-full w-11 h-11 p-2 text-white hover:bg-theme-36 bg-theme-36">
                                        <HomeIcon class="!stroke-2"/>
                                        </button>
                                    </div>
                                    <div class="ml-auto">
                                        <div class="font-medium text-gray-600">ความเป็นอยู่</div>
                                        <div class="text-custom-member text-md mt-0.5 text-right text-4xl" style="min-height: 40px;">
                                            {{statsProblemData?.allstats?.length>0 ? millionShortNum(statsProblemData.allstats[0].prob_family) + ' '+ millionShortString(statsProblemData.allstats[0].prob_family) : 0}}
                                        </div>
                                    </div>
                                </div>
                                <div class="box px-3 py-1 mb-3 flex items-center zoom-in bg-gray-100 box-shadow text-right font-bold">
                                    <div class="w-11 h-11 flex-none image-fit rounded-md overflow-hidden">
                                        <button class="btn btn-secondary mr-1 border-0 rounded-full w-11 h-11 p-2 text-white hover:bg-theme-36 bg-theme-36">
                                        <BookOpenIcon class="!stroke-2"/>
                                        </button>
                                    </div>
                                    <div class="ml-auto">
                                        <div class="font-medium text-gray-600">การศึกษา</div>
                                        <div class="text-custom-member mt-0.5 text-right text-4xl" style="min-height: 40px;">
                                            {{statsProblemData?.allstats?.length>0 ? millionShortNum(statsProblemData.allstats[0].prob_education) + ' '+ millionShortString(statsProblemData.allstats[0].prob_education) : 0}}
                                        </div>
                                    </div>
                                </div>
                                <div class="box px-3 py-1 mb-3 flex items-center zoom-in bg-gray-100 box-shadow text-right font-bold">
                                    <div class="w-11 h-11 flex-none image-fit rounded-md overflow-hidden">
                                        <button class="btn btn-secondary mr-1 border-0 rounded-full w-11 h-11 p-2 text-white hover:bg-theme-36 bg-theme-36">
                                        <DollarSignIcon class="!stroke-2"/>
                                        </button>
                                    </div>
                                    <div class="ml-auto">
                                        <div class="font-medium text-gray-600">รายได้</div>
                                        <div class="text-custom-member text-md mt-0.5 text-right text-4xl" style="min-height: 40px;">
                                            {{statsProblemData?.allstats?.length>0 ? millionShortNum(statsProblemData.allstats[0].prob_occupation) + ' '+ millionShortString(statsProblemData.allstats[0].prob_occupation) : 0}}
                                        </div>
                                    </div>
                                </div>
                                <div class="box px-3 py-1 flex items-center zoom-in bg-gray-100 box-shadow text-right font-bold">
                                    <div class="w-11 h-11 flex-none image-fit rounded-md overflow-hidden">
                                        <button class="btn btn-secondary mr-1 border-0 rounded-full w-11 h-11 p-2 text-white hover:bg-theme-36 bg-theme-36">
                                        <GiftIcon class="!stroke-2"/>
                                        </button>
                                    </div>
                                    <div class="ml-auto">
                                        <div class="font-medium text-gray-600">การเข้าถึงบริการภาครัฐ</div>
                                        <div class="text-custom-member mt-0.5 text-right text-4xl" style="min-height: 40px;">
                                            {{statsProblemData?.allstats?.length>0 ? millionShortNum(statsProblemData.allstats[0].prob_accessibility) + ' '+ millionShortString(statsProblemData.allstats[0].prob_accessibility): 0}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-span-12 dashboard2:col-span-4">
                    <div class="report-box-2 intro-y mt-2 h-full">
                        <LoadingScreen
                            :ifLoading="loadingBarGraph"
                        />
                        <div class="box p-5 h-full">
                            <div class="flex items-center text-custom-member">
                                สภาพปัญหาของสมาชิก (คน)
                            </div>
                            <div class="mt-2 h-max">
                                <StackedBarChart :height="550" :seriesData="statsProblemDataForBarGraph"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
         <div class="col-span-12 mt-5 mb-5">
            <div class="grid grid-cols-12 gap-6 relative">
                <div class="col-span-12 lg:col-span-4">
                    <div class="report-box-2 intro-y mt-2 h-full relative">
                        <LoadingScreen
                            :ifLoading="loadingDonut"
                        />
                        <div class="box p-3 h-full">
                            <div class="flex items-center text-custom-member font-bold">
                                ครัวเรือน
                            </div>
                            <div class="h-full flex items-center">
                                <OverviewDonutChart
                                    :seriesData="householdSeriesDataComputed"
                                    :chartLabel="['อยู่คนเดียว', 'ครัวเรือนเดี่ยว', 'ครัวเรือนขยาย']"
                                    :totalData="totalAmountComputed"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-span-12 lg:col-span-4">
                    <div class="report-box-2 intro-y mt-2 h-full relative">
                        <LoadingScreen
                            :ifLoading="loadingRadar"
                        />
                        <div class="box p-3 h-full">
                            <div class="flex items-center text-custom-member font-bold">
                                ครอบครัว
                            </div>
                            <div class="h-full flex items-center">
                                <RadarChart
                                    :seriesData="radarSeriesData"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-span-12 lg:col-span-4">
                    <div class="report-box-2 intro-y mt-2 h-full relative">
                        <LoadingScreen
                            :ifLoading="loadingFragile"
                        />
                        <div class="box p-3 h-full">
                            <div class="flex items-center text-custom-member font-bold mb-4">
                                จำนวนครัวเรือนเปราะบาง
                            </div>
                            <div class="h-full mt-2">
                                <FragileCard :data="fragileData" @click:dimension="getFragileStats"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
         </div>
    </div>
</template>

<script setup>
import StackedBarChart from '@/components/stacked-bar-chart/Main.vue'
import { computed, defineComponent, reactive, ref, watch, onMounted } from 'vue'
import searchDropdown from "../container/searchDropdown.vue"
import axios from "axios";
import Swal from "sweetalert2";
import OverviewDonutChart from "@/components/overview-donut-chart/Main.vue"
// import RadarChart from "@/components/radar-chart/index.vue"
import RadarChart from "@/components/radar-chart-echart/index.vue"
import FragileCard from "../container/FragileCard.vue"
import {millionShortNum,millionShortString} from "@/utils/format-number"
// import { useStore } from "vuex"
import LoadingScreen from "@/components/loading-screen/index.vue"

const swalCustom = Swal.mixin({
  customClass: {
    confirmButton: "btn btn-primary m-1",
    cancelButton: "btn btn-outline-secondary m-1",
  },
  buttonsStyling: false,
});
const emit = defineEmits(["updateOverAll"])
const selectState = ref('hh')
const valueSelected = ref('ทั้งประเทศ')
const options = reactive(['ทั้งประเทศ', 'สำนักงานส่งเสริมและสนับสนุนวิชาการ','จังหวัด'])
const showModal = ref(false)
const searchResult = ref(null)
const showDropdownFilter = ref(false)
const searchResultText = ref(null)
const currentSelected = ref('ทั้งประเทศ') //temp previous selected for handle in case cancel , use this value for search condition ok clicked
const currentSearching = ref(null)
const statsProblemData = ref()
// const store = useStore()
const status = ref("all")
const loadingStat = ref(false)
const handleModal = (val) => {//when select change show modal
    if(val == "สำนักงานส่งเสริมและสนับสนุนวิชาการ" || val == "จังหวัด"){
        showModal.value = !showModal.value
    }
}
const handleSelectedChange = (val) => {
    if(val == "สำนักงานส่งเสริมและสนับสนุนวิชาการ" || val == "จังหวัด"){
        showDropdownFilter.value = !showDropdownFilter.value
    }
    else if(val=="ทั้งประเทศ" && currentSelected.value != "ทั้งประเทศ"){
        currentSelected.value = "ทั้งประเทศ"
        searchResultText.value = null
        currentSearching.value = null
        getStatisticsData(false)
        getStatisticsData(true)
        getHouseTypeStat()
        getFamilyTypeStats()
        getFragileStats()
    }
}
const handleClickCancel = () => {
    valueSelected.value = currentSelected.value
    showDropdownFilter.value = false
}
const handleOpenDropdown = () =>{//close filter when open main dropdown
    showDropdownFilter.value = false
    valueSelected.value = currentSelected.value
}
const handleSearch = (val) => {
    //set props to selected dropdown and current value to search
    currentSearching.value = val
    currentSelected.value = valueSelected.value
    let text = ""
    if(valueSelected.value == "จังหวัด" && val){
        if(val.province){
            text += "จังหวัด"+val.province.province_name
            if(val.district){
                text += " อำเภอ"+val.district.amphur_name
            }
            if(val.subdistrict){
                text += " ตำบล"+val.subdistrict.tumbol_name
            }
            if(val.village){
                text += " หมู่บ้าน"+val.village.village_name
            }
        }
        searchResultText.value = text
    }
    else if(valueSelected.value == "สำนักงานส่งเสริมและสนับสนุนวิชาการ" && val){
        if(val.organize){
            searchResultText.value = val.organize.text
        }
    }
    getStatisticsData(false)
    getStatisticsData(true)
    getHouseTypeStat()
    getFamilyTypeStats()
    getFragileStats()
}
const getTotalOverall = async ()=>{
    const url = `${process.env.VUE_APP_BASE_API}member/getOverallStats/`;
    try{
        const res = await axios
        .post(url)
        if (res.status === 200) {
            emit("updateOverAll",res.data)
        }
        else {
            swalCustom.fire({
                icon: "warning",
                text: "ระบบผิดพลาด",
            });
        }
    }
    catch(err){
        console.log("error", err);
        swalCustom.fire({
            icon: "warning",
            text: "ระบบผิดพลาด",
        });
    }
}
const statsProblemDataForBarGraph = ref()
const loadingBarGraph = ref(false)
const getStatisticsData = async (isLoadingBarGraph)=>{
    let loadingObj = isLoadingBarGraph ? { load: loadingBarGraph }: { load: loadingStat }
    let statsProblemDataObj = isLoadingBarGraph ? { stats: statsProblemDataForBarGraph } : { stats: statsProblemData }
    try{
        loadingObj.load.value = true
        let reqData = {}
        if(currentSelected.value == "ทั้งประเทศ"){
            if(selectState.value){
                reqData.groupby = isLoadingBarGraph ? "member" : selectState.value
            }
            if(status.value != "all"){
                reqData.status = status.value
            }
        }
        else{//params get from currentSearching.value for osm, prov
            if(selectState.value){
                reqData.groupby = isLoadingBarGraph ? "member" : selectState.value
            }
            //if all send what value
            if(status.value != "all"){
                reqData.status = status.value
            }
            if(currentSearching.value?.province){
                reqData.prov = currentSearching.value.province._id.province_ID.toString()
                if(currentSearching.value.district)
                    reqData.amp = currentSearching.value.district._id.amphur_ID.toString()
                if(currentSearching.value.subdistrict)
                    reqData.tam = currentSearching.value.subdistrict._id.tumbol_ID.toString()
                if(currentSearching.value.village)
                    reqData.vil = currentSearching.value.village._id.village_ID.toString()
            }
            if(currentSearching.value?.organize){
                reqData.osm = currentSearching.value.organize.value
            }
        }
        const config = {
            url: `${process.env.VUE_APP_BASE_API}member/getMemberProblemStats/`,
            method: 'POST',
            data: reqData
        };
        const result = await axios(config)
        if (result.status === 200) {
            statsProblemDataObj.stats.value = result.data
            loadingObj.load.value = false
        }
        else {
            swalCustom.fire({
                icon: "warning",
                text: "ระบบผิดพลาด",
            });
            loadingObj.load.value = false
        }
    }
    catch(err){
        console.log("error", err);
        loadingObj.load.value = false
        swalCustom.fire({
            icon: "warning",
            text: "ระบบผิดพลาด",
        });
    }
}
onMounted(() => {
    //edit 28.6.22
    valueSelected.value = "จังหวัด"
    currentSelected.value = "จังหวัด"
    searchResultText.value = "จังหวัดปทุมธานี"
    currentSearching.value = {
        province:{
            mso_osm: 1,
            province_name: "ปทุมธานี",
            _id:{
                province_ID: 13
            }
        },
        district: null,
        suddistrict: null,
        village: null
    }
    getTotalOverall();
    getStatisticsData(false)
    getStatisticsData(true)
    getHouseTypeStat()
    getFamilyTypeStats()
    getFragileStats()
});
watch(()=> selectState.value,(val) =>{
    if(val){
        getStatisticsData(false)
    }
})
const seriesData = ref()
const loadingDonut = ref(false)
const getHouseTypeStat = async ()=>{
    loadingDonut.value = !loadingDonut.value
    let reqData={}
    if(currentSearching.value?.province){
        reqData.prov = currentSearching.value.province._id.province_ID.toString()
        if(currentSearching.value.district)
            reqData.amp = currentSearching.value.district._id.amphur_ID.toString()
        if(currentSearching.value.subdistrict)
            reqData.tam = currentSearching.value.subdistrict._id.tumbol_ID.toString()
        if(currentSearching.value.village)
            reqData.vil = currentSearching.value.village._id.village_ID.toString()
    }
    if(currentSearching.value?.organize){
        reqData.osm = currentSearching.value.organize.value
    }
    const config = {
        url: `${process.env.VUE_APP_BASE_API}household/getHouseTypeStats`,
        method: 'POST',
        data: reqData
    };
    const result = await axios(config)
    .catch(()=>{
        setTimeout(()=>{loadingDonut.value = !loadingDonut.value}, 500)
        Swal.fire({
            icon: "warning",
            text: "ระบบผิดพลาด",
        })
    })
    if (result.status === 200) {
        seriesData.value = result.data
        setTimeout(()=>{loadingDonut.value = !loadingDonut.value}, 500)
    }
}

const householdSeriesDataComputed =computed(()=>{
    let result = [0,0,0]
    if(seriesData.value){
        result = [seriesData.value.hh_type["อยู่คนเดียว"], seriesData.value.hh_type["ครัวเรือนเดี่ยว"], seriesData.value.hh_type["ครัวเรือนขยาย"]]
    }
  return result
})
const totalAmountComputed = computed(()=>{
    let total = 0
    if(seriesData.value){
        total += seriesData.value.hh_type["อยู่คนเดียว"] + seriesData.value.hh_type["ครัวเรือนเดี่ยว"] + seriesData.value.hh_type["ครัวเรือนขยาย"]
    }

    return total
})

const familyTypeStatData = ref()
const loadingRadar = ref(false)
const getFamilyTypeStats = async ()=>{
    loadingRadar.value = !loadingRadar.value
    let reqData={}
    if(currentSearching.value?.province){
        reqData.prov = currentSearching.value.province._id.province_ID.toString()
        if(currentSearching.value.district)
            reqData.amp = currentSearching.value.district._id.amphur_ID.toString()
        if(currentSearching.value.subdistrict)
            reqData.tam = currentSearching.value.subdistrict._id.tumbol_ID.toString()
        if(currentSearching.value.village)
            reqData.vil = currentSearching.value.village._id.village_ID.toString()
    }
    if(currentSearching.value?.organize){
        reqData.osm = currentSearching.value.organize.value
    }
    const config = {
        url: `${process.env.VUE_APP_BASE_API}family/getFamilyTypeStats/`,
        method: 'POST',
        data: reqData
    };
    const result = await axios(config)
    .catch(()=>{
        setTimeout(()=>{loadingRadar.value = !loadingRadar.value}, 500)
        Swal.fire({
            icon: "warning",
            text: "ระบบผิดพลาด",
        })
    })
    if (result.status === 200) {
        familyTypeStatData.value = result.data
        setTimeout(()=>{loadingRadar.value = !loadingRadar.value}, 500)
    }
}

const chartRadarLabels = reactive([
    ['ครอบครัวคู่รัก','เพศเดียวกัน'],
    ['ครอบครัวผสม'],
    ['อยู่คนเดียว'],
    ['ครอบครัวขยาย'],
    ['ครอบครัววัยรุ่น'],
    ['ครอบครัวเดี่ยว'],
    ['ครอบครัวข้ามรุ่น'],
    ['ครอบครัวพ่อแม่','เลี้ยงเดี่ยว'],
    ['ครอบครัวผู้สูงอายุ','อยู่ด้วยกันตามลำพัง']
])
const radarSeriesData = computed(()=>{
    let result = [0,0,0,0,0,0,0,0,0]
    if(familyTypeStatData.value){
        result = [
            familyTypeStatData.value.fam_type["ครอบครัวคู่รักเพศเดียวกัน"],familyTypeStatData.value.fam_type["ครอบครัวผสม"],
            familyTypeStatData.value.fam_type["อยู่คนเดียว"],
            familyTypeStatData.value.fam_type["ครอบครัวขยาย"],
            familyTypeStatData.value.fam_type["ครอบครัววัยรุ่น"],familyTypeStatData.value.fam_type["ครอบครัวเดี่ยว"],
            familyTypeStatData.value.fam_type["ครอบครัวข้ามรุ่น"],familyTypeStatData.value.fam_type["ครอบครัวพ่อหรือแม่เลี้ยงเดี่ยว"],
            familyTypeStatData.value.fam_type["ครอบครัวผู้สูงอายุอยู่ด้วยกันตามลำพัง"]
        ]
    }
    return result
})
const fragileStatsData = ref()
const loadingFragile = ref(false)
const getFragileStats = async (evt = null)=>{
    loadingFragile.value = !loadingFragile.value
    let reqData={
        prob_health: evt?.includes("health") ? 1 : 0,
        prob_education: evt?.includes("education") ? 1 : 0,
        prob_occupation: evt?.includes("occupation") ? 1 : 0,
        prob_family: evt?.includes("family") ? 1 : 0,
        prob_accessibility: evt?.includes("accessibility") ? 1 : 0
    }
    if(currentSearching.value?.province){
        reqData.prov = currentSearching.value.province._id.province_ID.toString()
        if(currentSearching.value.district)
            reqData.amp = currentSearching.value.district._id.amphur_ID.toString()
        if(currentSearching.value.subdistrict)
            reqData.tam = currentSearching.value.subdistrict._id.tumbol_ID.toString()
        if(currentSearching.value.village)
            reqData.vil = currentSearching.value.village._id.village_ID.toString()
    }
    if(currentSearching.value?.organize){
        reqData.osm = currentSearching.value.organize.value
    }
    const config = {
        url: `${process.env.VUE_APP_BASE_API}member/getFragileStats/`,
        method: 'POST',
        data: reqData
    };
    const result = await axios(config)
    .catch(()=>{
        setTimeout(()=>{loadingFragile.value = !loadingFragile.value}, 500)
        Swal.fire({
            icon: "warning",
            text: "ระบบผิดพลาด",
        })
    })
    if (result.status === 200) {
        fragileStatsData.value = result.data.fragile
        setTimeout(()=>{loadingFragile.value = !loadingFragile.value}, 500)
    }
}
const fragileData = computed(()=>{
    let result = {
        "fg0": 0,
        "fg1": 0,
        "fg2": 0,
        "fg3": 0
    }
    if(fragileStatsData.value){
        result = fragileStatsData.value
    }
    return result
})
const selectStateComputed = computed(() => {
    if(selectState.value == "hh"){
        return "ครัวเรือน"
    }
    else if(selectState.value == "fam"){
        return "ครอบครัว"
    }
    else if(selectState.value == "member"){
        return "สมาชิก"
    }
  return "Error"
})
</script>

<style lang="scss" scoped>
input[type="radio"] {
  display: none;
}
.box-shadow{
  box-shadow: 0px 3px 6px rgb(0 0 0 / 16%);
}
.vs__dropdown-toggle{
    background: #FFF;
}
.vs__search{
    font-size: 0.75rem;
}
</style>